module.exports = __webpack_public_path__ + "img/icon-googleplay_4786r064.de488d5f.png";